export default __webpack_public_path__ + "static/media/cancel-new.21250b25.svg";